module.exports = __webpack_public_path__ + "static/media/csv_format_upload_corporate_users.39c6fea1.csv";